@for (campaign of activeCampaigns; track campaign.id) {
  <app-campaign-banner [config]="campaign"></app-campaign-banner>
}
<app-slider [sliderItems]="sliderItems"></app-slider>
<app-designer-cards></app-designer-cards>
<app-download-section></app-download-section>
